import { LoadingNote } from "@/components/ui/loading";

/**
 * The router's default while a route's loader runs.
 *
 * The plainest of the loading states, and now a blank canvas: a route can be
 * any shape, so there is no skeleton to hold, and the app draws no spinners.
 * The wait is announced and nothing else. A route that knows its own shape
 * holds that shape with its own `pendingComponent` — `_app` does — which is
 * the answer for any route where a blank moment is too long.
 */
export function PendingPage() {
  return (
    <div className="bg-canvas grid min-h-dvh place-items-center px-5">
      <LoadingNote />
    </div>
  );
}
